import styled from "styled-components";

export const Content = styled.div`
   width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .details {
          width: 100%;
          display: flex;
          align-items: flex-start;
          .left {
            display: flex;
            flex-direction: column;
            margin-right: 20px;
            align-items: end;
            gap: 5px;
          }
          .right {
            display: flex;
            flex-direction: column;
            font-weight: 600;
            gap: 5px;
          }
        }
`;
